const ISO_DAY = /^(\d{4})-(\d{2})-(\d{2})/;

/** dd/MM/yyyy dalla sola parte data della stringa (nessun fuso orario coinvolto). */
export function formatIsoDay(isoDay: string): string {
  const match = ISO_DAY.exec(isoDay);
  return match ? `${match[3]}/${match[2]}/${match[1]}` : isoDay;
}
